// 1. settings menu
// 2. quick search

// real modules

// fake modules

// other

import SettingsModule from "../../../../core/modules/settings-module";
import TaskTypesSettingsModule from "../../../../app/settings/tasks-projects/task-types/list/settings-module";
import PrioritiesSettingsModule from "../../../../app/settings/tasks-projects/priorities/settings-module";
import ProjectTemplatesSettingsModule from "../../../../app/settings/tasks-projects/templates/settings-module";
import CustomFieldsSettingsModule from "../../../../app/settings/tasks-projects/custom-fields/settings-module";
import TodoListSettingsModule from "../../../../app/settings/tasks-projects/todo-list/settings-module";
import StatusesSettingsModule from "../../../../app/settings/tasks-projects/statuses/settings-module";
import SkillsSettingsModule from "../../../../app/settings/users/skills/settings-module";
import UserCustomFieldsSettingsModule from "../../../../app/settings/users/custom-fields/settings-module";
import WorkScheduleSettingsModule from "../../../../app/settings/users/work-schedule/settings-module";
import DepartmentsSettingsModule from "../../../../app/settings/users/departments/settings-module";
import CompanyRoleSettingsModule from "../../../../app/settings/access/organization-role/settings-module";
import ProjectAccessSettingsModule from "../../../../app/settings/access/project-access/settings-module";
import FullAccessSettingsModule from "../../../../app/settings/access/full-access/settings-module";
import SettingsModuleAccountAdministration
    from "../../../../app/settings/company/account-administration/settings-module";
import SettingsModuleSubscription from "../../../../app/settings/company/subscription/current-plan/settings-module";
import SettingsModuleDataStorage from "../../../../app/settings/system/data-storage/settings-module";
import SettingsModuleAdmins from "../../../../app/settings/users/admins/settings-module";
import LoginWithAppleSettingsModule from "../../../../app/integrations/settings/sso-apple/settings-module";
import GmailSettingsModule from "../../../../app/integrations/settings/gmail/settings-module";
import SAMLSettingsModule from "../../../../app/integrations/settings/sso-saml/settings-module";
import SharepointSettingsModule from "../../../../app/integrations/settings/sharepoint/settings-module";
import TeamsSettingsModule from "../../../../app/integrations/settings/teams/settings-module";
import ZapierSettingsModule from "../../../../app/integrations/settings/zapier/settings-module";
import SettingsModuleViewsAccess from "../../../../app/settings/views/views-access/settings-module";
import CompanyUsersSettingsModule from "../../../../app/settings/users/company-users/settings-module";
import SettingsOrganizationProfile from "../../../../app/settings/company/organization-profile/settings-module";
import SettingsAutomationsLogs from "../../../../app/settings/system/automations-logs/settings-module";
import SettingsDataArrivesQueue from "../../../../app/settings/system/date-arrives-queue/settings-module";
import SettingsCreateTaskViaEmailLogs from "../../../../app/settings/system/create-task-via-email/settings-module";
import SettingsTaskReplyViaEmailLogs from "../../../../app/settings/system/task-reply-via-email/settings-module";
import {GroupedData} from "../../../../core/data-structures/group";

export default class SettingsSearch {

    private searchByName        : boolean
    private searchByDescription : boolean
    private searchByKeywords    : boolean

    private settingsModules?    : SettingsModule[]

    constructor(searchByName:boolean, searchByDescription:boolean, searchByKeywords:boolean) {
        this.searchByName           = searchByName
        this.searchByDescription    = searchByDescription
        this.searchByKeywords       = searchByKeywords
    }

    private initSettingsModules() {
        this.settingsModules = _.compact([

            // taks & projectys
            gd.modules.dependencies,

            //

            gd.modules.validations,
            gd.modules.requests,
            gd.modules.publicForms,
            // gd.modules.sharedViews, //???????
            gd.modules.expenses,
            gd.modules.invoices,
            gd.modules.laborCost,
            gd.modules.twoFA,
            gd.modules.emailTemplates,
            gd.modules.events,
            gd.modules.tags,
            gd.modules.pages,
            gd.modules.publicSharing,
            gd.modules.portfolio,
            gd.modules.reportsAnalytics,
            gd.modules.attachments,
            gd.modules.automations,
            gd.modules.goals,
            gd.modules.dashboards,
            gd.modules.reactions,
            gd.modules.reminders,
            gd.modules.meetings,
            gd.modules.storyPoints,
            gd.modules.documents,
            gd.modules.notepad,
            gd.modules.chats,
            gd.modules.timeTracking,
            gd.modules.workload,
            gd.modules.clockInOut,
            gd.modules.guesstimate,
            gd.modules.crmAccount,
            gd.modules.crmContact,
            gd.modules.crm,
            gd.modules.customerPortal,
            gd.modules.gdLabs,
            gd.modules.offices,

            gd.modules.viewList,
            gd.modules.viewTable,
            gd.modules.viewBoard,
            gd.modules.viewCalendar,
            // gd.modules.viewEventsSummary,
            gd.modules.viewGantt,
            gd.modules.viewWorkload,

            new SettingsModuleViewsAccess(),
            new CompanyUsersSettingsModule(),
            new SettingsOrganizationProfile(),


            new TaskTypesSettingsModule(),
            new ProjectTemplatesSettingsModule(),
            new CustomFieldsSettingsModule(),
            new TodoListSettingsModule(),
            new StatusesSettingsModule(),
            new PrioritiesSettingsModule(),

            new SkillsSettingsModule(),
            new UserCustomFieldsSettingsModule(),
            new WorkScheduleSettingsModule(),
            new DepartmentsSettingsModule(),
            new CompanyRoleSettingsModule(),
            new ProjectAccessSettingsModule(),
            new FullAccessSettingsModule(),
            new SettingsModuleAccountAdministration(),
            new SettingsModuleSubscription(),
            new SettingsModuleDataStorage(),
            new SettingsModuleAdmins(),

            // System
            new SettingsAutomationsLogs(),
            new SettingsDataArrivesQueue(),
            new SettingsCreateTaskViaEmailLogs(),
            new SettingsTaskReplyViaEmailLogs(),

            // integrations

            gd.modules.googleSuite,
            gd.modules.googleCalendar,
            gd.modules.outlookCalendar,
            gd.modules.googleDrive.enabled ? gd.modules.googleDrive : null, // temporary remove from search if googleDrive is disabled
            gd.modules.slack,
            gd.modules.github,
            gd.modules.gitlab,
            gd.modules.dropbox,
            gd.modules.ssoGoogle,
            gd.modules.createTaskViaEmail,
            gd.modules.emailReply,


            new LoginWithAppleSettingsModule(),
            new GmailSettingsModule(),
            // new OutlookCalendarSettingsModule(),
            new SAMLSettingsModule(),
            new SharepointSettingsModule(),
            new TeamsSettingsModule(),
            new ZapierSettingsModule()


        ])
    }

    searchAndGroup(keyword: string): GroupedData {

        const modules = this.search(keyword).sort((a, b)=>a.name.localeCompare(b.name))

        const groups = _.chain(modules).groupBy('settingsMenuTopCategory').value();

        return Object.keys(groups).map((key: string)=>{
            return {
                sortValue  : key,
                label      : key,
                items      : groups[key]
            }
        })
    }

    search(keyword: string):SettingsModule[] {

        if (!this.settingsModules) this.initSettingsModules()

        let foundModules : SettingsModule[]   = []

        if (this.searchByName) {
            _.map(this.settingsModules, (settingModule)=>{
                if (settingModule.search(keyword, true, false, false)) {
                    foundModules.push(settingModule)
                }
            })
        }

        if (this.searchByKeywords || this.searchByDescription) {
            _.map(this.settingsModules, (settingModule)=>{
                if (settingModule.search(keyword, false, true, true)) {
                    foundModules.push(settingModule)
                }
            })
        }

        foundModules = _.uniq(foundModules)

        return foundModules
    }
}
